module.exports = __webpack_public_path__ + "img/Advertiser.64dfb780.svg";